import http from './default'

export default class PowerExtensionService {
  static async getPortals(client) {
    const powerExtensions = `${process.env.REACT_APP_POWER_EXTENSION_CONFIGURATION}/v1/client/${client}/power-extensions`
    const response = await http.get(powerExtensions)

    return response
  }

  static async getPortalLocations(client, portal) {
    const locations = `${process.env.REACT_APP_POWER_EXTENSION_CONFIGURATION}/v1/client/${client}/portal/${portal}/locations`
    const response = await http.get(locations)

    return response
  }

  static async postPortalLocations(client, portal, body) {
    const locations = `${process.env.REACT_APP_POWER_EXTENSION_CONFIGURATION}/v1/client/${client}/portal/${portal}/locations`
    const response = await http.post(locations, body)

    return response
  }
}
